import { Divider } from '@mui/material'
import {
  AzureOfferPlan,
  AzurePricingType,
} from '../../../modules/privateOffer/types'
import { Product } from '../../../modules/productsListing/types'
import {
  useStyles,
  useStyles as usePricingStyles,
} from '../MicrosoftViewPricing.styles'
import { PlanBasicDetail } from '../PlanBasicDetail/PlanBasicDetail'
import { SectionWrapper } from '../../../common/components/SectionWrapper/SectionWrapper'
import { faListCheck } from '@fortawesome/pro-regular-svg-icons'
import { DetailInfo, DetailRow } from '@labrav/common'
import { isNonEmptyNumber } from '@labrav/common'

import { DisplayNumberValue } from '../PlanMeteringDimensions/PlanMeteringDimensions'
import {
  getVmPlanTcvValue,
  getVmSystemMeterPriceTitle,
  shouldShowVmTcv,
} from '../../MicrosoftFormComponent/VmPlan/vmPlanUtils'
import { isContainerDiscountPricingType } from '../../MicrosoftFormComponent/ContainerPlan/containerPlanUtils'

export const VmViewPricing = ({
  plans,
  azurePricingType,
  product,
}: {
  plans?: AzureOfferPlan[]
  azurePricingType?: AzurePricingType
  product?: Product
}) => {
  const { classes } = useStyles()
  const { classes: pricingClasses } = usePricingStyles()

  if (!plans || plans.length === 0) {
    return (
      <div>
        <SectionWrapper heading="Pricing Plans" icon={faListCheck}>
          <div className={classes.sectionContent}>
            <div className={classes.emptyState}>No plans available</div>
          </div>
        </SectionWrapper>
      </div>
    )
  }

  return (
    <div>
      <SectionWrapper heading="Pricing configuration" icon={faListCheck}>
        <div className={classes.sectionContent}>
          {plans.map((plan, index) => {
            const showTcv = shouldShowVmTcv(plan, product)
            const isDiscountPricing =
              isContainerDiscountPricingType(azurePricingType)
            const discountPercentage = isNonEmptyNumber(plan.discountPercentage)
              ? plan.discountPercentage
              : undefined
            const showDiscount =
              isDiscountPricing && discountPercentage !== undefined
            const showBillingTerms = showTcv || showDiscount

            return (
              <div
                key={plan.labraPlanId || plan.planId || index}
                className={classes.planCard}
              >
                <PlanBasicDetail
                  azurePricingType={azurePricingType}
                  plan={plan}
                  index={index}
                  hideDiscount
                />

                {showBillingTerms && (
                  <>
                    <Divider className={classes.divider} />
                    <div
                      className={pricingClasses.subHeading}
                      style={{ marginBottom: '-24px' }}
                    >
                      Billing Terms
                    </div>
                    <DetailRow borderBottom>
                      <>
                        {showTcv && (
                          <DetailInfo
                            title={getVmSystemMeterPriceTitle(
                              plan,
                              azurePricingType,
                              product
                            )}
                            value={
                              <DisplayNumberValue
                                isPrice
                                shouldFormat
                                isPrecisionDigit={false}
                                value={getVmPlanTcvValue(plan)}
                              />
                            }
                            keyName="vmTcv"
                            gridSize={showDiscount ? 4 : 4}
                          />
                        )}
                        {showDiscount && (
                          <DetailInfo
                            title="Discount(%)"
                            value={`${discountPercentage}`}
                            keyName="discountPercentage"
                            gridSize={4}
                          />
                        )}
                      </>
                    </DetailRow>
                  </>
                )}
              </div>
            )
          })}
        </div>
      </SectionWrapper>
    </div>
  )
}
